import { UiText } from '@ory/kratos-client';
import { Alert, AlertContent } from '@ory/themes';

interface MessageProps {
  message: UiText;
}

export const Message = ({ message }: MessageProps) => {
  return (
    <Alert severity={message.type === 'error' ? 'error' : 'info'}>
      <AlertContent data-testid={`ui/message/${message.id}`}>
        <div className={`font-sans ${message.type === 'error' ? 'text-red-500' : ''}`}>{message.text}</div>
      </AlertContent>
    </Alert>
  );
};

interface MessagesProps {
  messages?: Array<UiText>;
}

export const Messages = ({ messages }: MessagesProps) => {
  if (!messages) {
    // No messages? Do nothing.
    return null;
  }

  return (
    <div>
      {messages.map((message) => (
        <Message key={message.id} message={message} />
      ))}
    </div>
  );
};
